import { useState, useEffect } from "react";
import { FormCustomControl } from "react-blueprint-library";

const ReviewCoveredAdvisorOnboarding = (props) => {
  const [reviewedChecked1] = useState(props.ackInfo);
  const [reviewedChecked2] = useState(props.ackInfo);
  const [reviewedChecked3] = useState(props.ackInfo);

  const COMPONENT_ID = {
    COVEREDADVISOR: "coveredadvisor",
  };

  const CHECKBOX_LABEL_COVEREDADVISOR_1 =
    "Have instructed the above listed Advisor that he/she is not to possess or retain originals or copies of any client files, client data or client records, either hard copy or electronic, to the extent prohibited by the producer’s priorfirm (“Prohibited Files”).";

  const CHECKBOX_LABEL_COVEREDADVISOR_2 =
    "Will conduct within 14 days a reasonable inspection of the above listed Advisor’s electronic and hard copy storage facilities used to maintain client files, client data and client records, and inquired of the producer to determine whether any Prohibited Files are within the producer’s possession.";

  const CHECKBOX_LABEL_COVEREDADVISOR_3 =
    "I certify that to the extent I learn that the above listed Advisor possesses any Prohibited Files, I will require him/her either to return or eliminate his/her access to such files and that periodic audits of his/her electronic and hard copy storage facilities will be conducted over the next 24 months to assess whether he/she may possess any Prohibited Files.";

  return (
    <div className="review-form background-regulatory-form">
      <h3>Covered Advisor Onboarding Certification</h3>
      <div className={COMPONENT_ID.COVEREDADVISOR + "-acknowledgements"}>
        <div style={{ marginTop: "20px" }}>
          <p style={{ marginBottom: "35px" }}>
            I certify that either the Agency Supervisory Officer or I:
          </p>
        </div>
        <div className="card--outline">
          <div className="card-body">
            <FormCustomControl
              id={"reviewed-checkbox-1" + COMPONENT_ID.COVEREDADVISOR}
              inputType="checkbox"
              label={CHECKBOX_LABEL_COVEREDADVISOR_1}
              aria-label="aria_reviewed_checkbox_finra"
              checked={props?.ackInfo || reviewedChecked1}
              disabled={
                (props?.ackInfo && "disabled") ||
                props.id === "confidential_covered_advisor"
              }
            />
            <FormCustomControl
              id={"reviewed-checkbox-2" + COMPONENT_ID.COVEREDADVISOR}
              inputType="checkbox"
              label={CHECKBOX_LABEL_COVEREDADVISOR_2}
              aria-label="aria_reviewed_checkbox_finra"
              checked={props?.ackInfo || reviewedChecked2}
              disabled={
                (props?.ackInfo && "disabled") ||
                props.id === "confidential_covered_advisor"
              }
            />
            <FormCustomControl
              id={"reviewed-checkbox-3" + COMPONENT_ID.COVEREDADVISOR}
              inputType="checkbox"
              label={CHECKBOX_LABEL_COVEREDADVISOR_3}
              aria-label="aria_reviewed_checkbox_finra"
              checked={props?.ackInfo || reviewedChecked3}
              disabled={
                (props?.ackInfo && "disabled") ||
                props.id === "confidential_covered_advisor"
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCoveredAdvisorOnboarding;
